<template>
  <div class="menubar" style="background-color:#007bff"> 
      <!--Navbar-->
  <nav class="navbar navbar-expand-lg navbar-dark primary-color">
    <!-- Collapse button -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#basicExampleNav"
      aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible content -->
    <div class="collapse navbar-collapse" id="basicExampleNav" style="disply:inline-block">

      <!-- Links -->
      <ul class="navbar-nav mr-auto">
        <li :class="activeTrangChu">
          <a class="nav-link" href="/" v-on:click="getItemHome()">Trang chủ |
          </a>
        </li>
        <!-- <li :class="activeVanChuyen">
          <a class="nav-link" href="/vanchuyen" v-on:click="getItemVanChuyen()">Vận chuyển |</a>
        </li>
        -->
        <li :class="activeXachTay">
          <a class="nav-link" href="/hang-xach-tay" v-on:click="getItemHangXachTay()"><span style="color:pink">Shop</span> |</a>
        </li> 
        <!-- <li :class="activeChiNhanhVN" >
              <a class="nav-link" href="/chi-nhanh-vn" v-on:click="getItemChiNhanhVN()">Chi nhánh tại Việt Nam |</a>
        </li>
        <li :class="activeChiNhanhJP" >
              <a class="nav-link" href="/chi-nhanh-jp" v-on:click="getItemChiNhanhJP()">Liên hệ tại Japan</a>
        </li> -->
        <!-- <li :class="activeThongTin" >
              <a class="nav-link" href="/about" v-on:click="getItemThongTin()">Thông tin doanh nghiệp </a>
        </li> -->

        <!-- Dropdown -->
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">Dropdown</a>
          <div class="dropdown-menu dropdown-primary" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something else here</a>
          </div> -->
         <!-- </li>  --> 

      </ul>
      <!-- Links -->

      <!-- <form class="form-inline">
        <div class="md-form my-0">
          <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search">
        </div>
      </form> -->
    </div>
    <!-- Collapsible content -->

  </nav>
  <!--/.Navbar-->
  </div>
</template>
<script>

import Constants from "@/components/Constants/Constants.js"
export default {
    props:{
        
    },
    data(){
        return{
        activeTrangChu: "nav-bar active",
        activeVanChuyen: String,
        activeXachTay: String,
        activeThongTin: String,
        activeChiNhanhVN: String,
        activeChiNhanhJP: String,
        };
    },
    methods:{
        getItemVanChuyen(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar active");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
        },
         getItemThongTin(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar active");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
        },
        getItemHome(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar active");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
        },
        getItemChiNhanhVN(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar active");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
        },
        getItemChiNhanhJP(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar active");
        },
        getItemHangXachTay(){
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar active");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
        }
    },
    created(){
        this.activeThongTin = localStorage.getItem(Constants.ITEM_THONG_TIN);
        this.activeTrangChu = localStorage.getItem(Constants.ITEM_HOME);
        this.activeVanChuyen= localStorage.getItem(Constants.ITEM_VAN_CHUYEN);
        this.activeChiNhanhVN=localStorage.getItem(Constants.ITEM_CHI_NHANH_VN);
        this.activeChiNhanhJP=localStorage.getItem(Constants.ITEM_CHI_NHANH_JP);
        this.activeXachTay = localStorage.getItem(Constants.ITEM_HANG_XACH_TAY);
        console.log("menu");
    }
}
</script>
<style scoped>
.menubar{
  z-index: 46 !important;
  position: static;
}
</style>